import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

const useStyles = createStyles(({ css }: any) => ({
  root: css``,
}));

export const useButtonRemoveCartStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
